import {
    readLastVisitedFromStorage,
} from '../CommonJs/locationStorage.js';
import { slugify } from '../CommonJs/slug.js';
import { pushDataLayerEvent } from '../CommonJs/dataLayer.js';

function renderLink(location) {
    const locationElement = document.createElement('a');
    locationElement.href = `/${slugify(location.country_name)}/${slugify(location.name)}/${location.location_id}`;
    locationElement.textContent = `${location.name}, ${location.country_name}`;
    if (location.location_id) locationElement.dataset.locationId = location.location_id;

    // Add tailwind classes
    locationElement.classList.add('bg-blue-50', 'text-gray-800', 'px-4', 'py-2', 'rounded-full', 'text-sm', 'font-medium', 'hover:bg-blue-100');

    return locationElement;
}

document.addEventListener('DOMContentLoaded', () => {
    const locations = readLastVisitedFromStorage();
    const lastVisitedElement = document.querySelector('.last-visited');
    lastVisitedElement.innerHTML = '';

    if (locations && locations.length > 0) {
        // Grab 3 newest locations
        const lastThreeLocations = locations.slice(-3);

        lastThreeLocations.reverse();

        lastThreeLocations.forEach(location => {
            const link = renderLink(location);

            lastVisitedElement.appendChild(link);
        });
    } else {
        const dutchLocations = [
            { location_id: 5575, name: 'Amsterdam', country_name: 'Nederland' },
            { location_id: 16707, name: 'Rotterdam', country_name: 'Nederland' },
            { location_id: 19344, name: 'Utrecht', country_name: 'Nederland' },
        ];

        const belgianLocations = [
            { location_id: 7196, name: 'Brussel', country_name: 'België' },
            { location_id: 5686, name: 'Antwerpen', country_name: 'België' },
            { location_id: 9866, name: 'Gent', country_name: 'België' },
        ];

        const locations = [];
        const domain = window.location.hostname;

        if (domain.includes('buienalarm.be')) {
            locations.push(...belgianLocations);
        } else {
            locations.push(...dutchLocations);
        }

        locations.forEach(location => {
            const link = renderLink(location);

            lastVisitedElement.appendChild(link);
        });
    }

    // Add a click event listener to the last visited element
    lastVisitedElement.addEventListener('click', function (event) {
        const link = event.target.closest('a');

        if (link) {
            pushDataLayerEvent({
                event: 'select_last_visited',
                click_name: link.textContent.trim(),
                ...(link.dataset.locationId && { location_id: link.dataset.locationId })
            });
        }
    });

    const appstore = document.querySelector('#apple');
    const playstore = document.querySelector('#google');

    if (appstore) {
        appstore.addEventListener('click', function () {
            pushDataLayerEvent({
                event: 'appstore_click',
                click_name: 'apple'
            });
        });
    }

    if (playstore) {
        playstore.addEventListener('click', function () {
            pushDataLayerEvent({
                event: 'appstore_click',
                click_name: 'google_play'
            });
        });
    }
});